import React from "react";
import Address from "../../components/address";
import Ratings from "../../components/ratings";
import SchoolManagement from "../../assets/sm.jpeg";
import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import Welcome1 from "../../assets/welcome-1.jpeg";
import Welcome2 from "../../assets/welcome-2.jpeg";
import DiscoverMore from "../../components/discovermore";

const ImpactData = [
  {
    number: "50,000+",
    description: "Active Users",
  },
  {
    number: "1,200+",
    description: "Schools Managed",
  },
  {
    number: "10,000+",
    description: "Positive Reviews",
  },
  {
    number: "5+",
    description: "Years in Service",
  },
];

const AboutUs = () => {
  return (
    <>
      <Box sx={{ backgroundColor: "#4b4993", p: 20 }}>
        {/* <Box
          component={"img"}
          src={Welcome1}
          sx={{
            objectFit: "cover",
            width: "50vw",
            opacity: 0.5,
          }}
        ></Box>
        <Box
          component={"img"}
          src={Welcome2}
          sx={{
            objectFit: "cover",
            width: "50vw",
            opacity: 0.5,
            backgroundImage: `url(${Welcome2})`,
          }}
        ></Box> */}
        <Box textAlign={"center"}>
          <Typography
            sx={{
              fontSize: "3.75rem",
              fontWeight: 700,
              color: "white",
            }}
          >
            Welcome to Helpsoo
          </Typography>
          <Typography
            sx={{
              fontSize: "1.125rem",
              color: "rgba(255,255, 255, 0.7)",
            }}
          >
            Connecting students and parents with school management effortlessly.
          </Typography>
        </Box>
      </Box>
      <DiscoverMore />
      <Box px={35} pt={10}>
        <Box sx={{ display: "flex" }}>
          <Box
            component={"img"}
            src={SchoolManagement}
            sx={{
              borderRadius: 3,
              width: "35vw",
              objectFit: "cover",
              aspectRatio: 1 / 1,
            }}
          ></Box>

          <Box px={10} alignSelf={"center"}>
            <Typography sx={{ color: "#245ECB", fontWeight: 600 }}>
              Our Impact
            </Typography>
            <Typography sx={{ fontSize: "2.25rem", fontWeight: 600 }}>
              Making a Difference
            </Typography>
            <Typography sx={{ py: 3, fontSize: "1.125rem", color: "#4b5563" }}>
              Helpsoo is dedicated to transforming school management, as
              reflected in our impressive statistics.
            </Typography>
            <Grid
              container
              columnSpacing={{ xs: 1, sm: 2, md: 3, lg: 6 }}
              rowSpacing={4}
            >
              {ImpactData.map((item) => {
                return (
                  <Grid item>
                    <Box sx={{ borderLeft: "1.5px solid #e6e6e6", px: 1 }}>
                      <Typography
                        sx={{
                          fontWeight: 600,
                          fontSize: "1.875rem",
                          px: 1.5,
                        }}
                      >
                        {item.number}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.875rem",
                          color: "#4b5563",
                          px: 1.5,
                        }}
                      >
                        {item.description}
                      </Typography>
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        </Box>
      </Box>

      <Ratings />
      <Address />
    </>
  );
};

export default AboutUs;
